import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'prof-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(private _auth: AuthService) { }

  ngOnInit() {
    this._auth.setOnboarding(false);
    this._auth.isAuthenticated$.subscribe((res: boolean) => {
      if (res) {
        this._auth.loginRedirect();
      } else {
        this._auth.login();
      }
    });
  }
}
